"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const extension_1 = require("../extension");
const function_1 = require("../function");
const var_dump_1 = require("../helper/var-dump");
const output_buffering_1 = require("../output-buffering");
const each_1 = require("../helper/each");
const template_1 = require("../template");
class TwingExtensionDebug extends extension_1.TwingExtension {
    getFunctions() {
        return new Map([
            [0, new function_1.TwingFunction('dump', twingVarDump, {
                    is_safe: ['html'],
                    needs_context: true,
                    needs_environment: true
                })],
        ]);
    }
}
exports.TwingExtensionDebug = TwingExtensionDebug;
function twingVarDump(env, context, ...vars) {
    if (!env.isDebug()) {
        return null;
    }
    output_buffering_1.TwingOutputBuffering.obStart();
    if (vars.length < 1) {
        let vars_ = new Map();
        each_1.each(context, (key, value) => {
            if (!(value instanceof template_1.TwingTemplate)) {
                vars_.set(key, value);
            }
        });
        var_dump_1.varDump(vars_);
    }
    else {
        var_dump_1.varDump(...vars);
    }
    return output_buffering_1.TwingOutputBuffering.obGetClean();
}
exports.twingVarDump = twingVarDump;
